module.exports = __webpack_public_path__ + "img/genicon-icons8-birthday.6387d289.svg";